import React from 'react';
import classNames from 'classnames';
import Button from '../Button';
import { useViewSize } from '@fff-web/fff-utilities';
import { type CarouselProps } from './interface';
import { CarouselContent } from './CarouselContent/CarouselContent';
import { CarouselButtons } from './CarouselButtons/CarouselButtons';
import { ProductItem } from './ProductItem/ProductItem';
import { useCarouselState } from './useCarouselState';
import { ReviewItem } from './ReviewItem/ReviewItem';
import styles from './Carousel.module.scss';

export const carouselId = 'carousel-container';

const Carousel = ({
  title,
  subtitle,
  subtitleBold,
  items,
  backgroundColor,
  variant,
  cta,
}: CarouselProps) => {
  const { isDesktop } = useViewSize();
  const { carouselRef, isFirstItemVisible, isLastItemVisible, scrollRight, scrollLeft } =
    useCarouselState();

  const carouselStyles = {
    backgroundColor: backgroundColor || 'transparent',
  };

  const itemsLength = items.length;
  const noCarouselStyle = classNames({ [styles.noCarouselStyle]: itemsLength < 5 });
  const renderArrowButton = itemsLength > 5 && isDesktop;

  const ctaStyles = classNames(styles.button, cta?.className);

  return (
    <div className={styles.wrapper} style={carouselStyles} data-testid={carouselId}>
      <h2 className={styles.title}>{title}</h2>
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      {renderArrowButton && (
        <CarouselButtons
          scrollLeft={scrollLeft}
          scrollRight={scrollRight}
          isFirstItemVisible={isFirstItemVisible}
          isLastItemVisible={isLastItemVisible}
        />
      )}
      <CarouselContent variant={variant} ref={carouselRef} className={noCarouselStyle}>
        {items &&
          items.map((item) => {
            const BASE_PROPS = {
              key: item.id,
              id: item.id,
              title: item.title,
              description: item.description,
              imageUrl: item.imageUrl,
              onClick: item.onClick,
            };
            if (item.variant === 'product') {
              return (
                <ProductItem
                  {...BASE_PROPS}
                  price={item?.price}
                  promotion={item?.promotion}
                  variant="product"
                  subtitleBold={subtitleBold ?? false}
                />
              );
            }
            return <ReviewItem {...BASE_PROPS} variant="review" />;
          })}
      </CarouselContent>
      {cta && (
        <Button onClick={cta.onClick} name={cta.name} className={ctaStyles}>
          {cta?.label}
        </Button>
      )}
    </div>
  );
};

export default Carousel;
